import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import mng from './mng';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  ...mng,
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
